import api from "@/plugins/api";
export class TransactionSearchService {
    static async search(term) {
        if (!term || term.trim().length < 3) {
            return [];
        }
        const response = await api.get("/transactions/search", {
            params: { term: term.trim() },
        });
        return (response.data ?? []);
    }
    /**
     * Resolve a public payment reference to a Adyen transaction id
     * Returns the PSP id as plain text from the backend
     */
    static async resolvePaymentReference(paymentReference) {
        if (!paymentReference || !paymentReference.trim()) {
            throw new Error("paymentReference is required");
        }
        const response = await api.get("/transactions/resolve", {
            params: { paymentReference },
            responseType: "text",
            transformResponse: [(data) => data],
        });
        // Axios with responseType:text keeps data as string
        const pspId = (response.data ?? "").toString().trim();
        if (!pspId) {
            throw new Error("Adyen transaction id not found");
        }
        return pspId;
    }
}
export default TransactionSearchService;
